<template>
    <v-select
        :value="value"
        class="tag-select"
        dense
        outlined
        v-bind="$attrs"
        :items="items"
        item-text="label"
        item-value="value"
        v-on="$listeners"
        @change="valueChanged"
    />
</template>

<script>
import { getEventClasses } from '@/models/EventClass';

export default {
    name: 'EventClassSelect',

    props: {
        value: {
            type: [String, Array],
            default: '',
        },
    },

    data() {
        return {
            eventClasses: getEventClasses(),
        };
    },

    computed: {
        items() {
            return this.eventClasses.models;
        },
        inputWidth() {
            if (this.value instanceof Array && this.value.length > 0) {
                return 0;
            }
            return '100%';
        },
    },

    methods: {
        valueChanged(newVal) {
            this.$emit('propertyChange', { property: 'event_class', value: newVal });
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.v-select__selections input) {
    width: v-bind(inputWidth);
}
:deep(.v-input__control) {
    justify-content: center;
}
</style>
